import { AxiosResponse } from 'axios';

/**
 * Gets the data from an AxiosResponse.
 * @param {getAxiosResponseData<T>} response - Gets an axios response and return the data.
 * @returns {T} - Response data.
 */
export const getAxiosResponseData = <T>({ data }: AxiosResponse<T>): T => data;

/**
 * Sleep for x ms.
 */
export default async function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
